import Icon from "components/Icon"

import { ComponentProps } from "."
import { Button } from "./styled"

const DEFAULT_ARIA_LABEL = "Share"
const DEFAULT_ICON_SIZE = "18px"

const ShareButton = ({
  ariaLabel = DEFAULT_ARIA_LABEL,
  className,
  disabled,
  iconSize = DEFAULT_ICON_SIZE,
  loading,
  noHoverHighlight,
  onClick,
  transparent,
  type = "button"
}: ComponentProps) => (
  <Button
    ariaLabel={ariaLabel}
    className={className}
    disabled={disabled}
    icon={
      <Icon ariaHidden group="fa6" name="FaShareFromSquare" size={iconSize} />
    }
    iconOnly
    loading={loading}
    noHoverHighlight={noHoverHighlight}
    onClick={onClick}
    transparent={transparent}
    type={type}
  />
)

export default ShareButton
